import { render } from "./RelRetirados.vue?vue&type=template&id=92783fa0"
import script from "./RelRetirados.vue?vue&type=script&lang=js"
export * from "./RelRetirados.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__